export default __webpack_public_path__ + "static/media/gmail.08f050a8.svg";